import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const MultiStepForm_Box_1 = styled.div`
  display: flex;
  width: calc(100% + 16px);
  margin-inline: -8px;
  margin-top: ${gutterWidth}px;
  justify-content: flex-end;
`;

export const MultiStepForm_Box_2 = styled.div`
  right: -36px;
  top: -24px;
  position: absolute;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    right: -60px;
    top: -28px;
  }
`;

export const MultiStepForm_Box_3 = styled.div`
  padding-inline: ${gutterWidth / 2}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: ${gutterWidth / 2}px;
  padding-bottom: ${(gutterWidth * 3) / 2}px;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-inline: ${gutterWidth}px;
  }
`;
